import { render } from "./push.vue?vue&type=template&id=bc0a55e4&lang=pug"
import script from "./push.vue?vue&type=script&lang=js"
export * from "./push.vue?vue&type=script&lang=js"

import "./push.vue?vue&type=style&index=0&id=bc0a55e4&lang=less"

import exportComponent from "/home/runner/work/argos-control-web/argos-control-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
